import graphql__bb765bfc74b5e23bd825 from "./__generated__/StartOralInterviewMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__bb765bfc74b5e23bd825;

const startOralInterview = (
  variables,
  onCompleted,
  onError = error => console.error(error)
) =>
  commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError
  });

export { startOralInterview };
